import React from 'react';
import styles from './Timeline.module.scss';
import { TooltipWrapper } from '@/components/TooltipWrapper';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
const START = 0; // 06:00 AM
const END = 24; // 09:00 PM

const toMinutes = (t) => {
  if (typeof t !== 'string' || !t.includes(':')) return NaN;
  const [h, m] = t.split(':').map(Number);
  return h * 60 + m;
};

const totalMinutes = (END - START) * 60;

export const TimelineChart = ({ segments = [] }) => {
  const drawable = segments.filter((seg) => {
    const start = toMinutes(seg?.start24H);
    const end = toMinutes(seg?.end24H);
    return Number.isFinite(start) && Number.isFinite(end) && end > start;
  });

  return (
    <div className={styles.timeline}>
      {/* Progress Track */}
      <div className={styles.track}>
        {drawable.map((seg, i) => {
          const start = toMinutes(seg.start24H) - START * 60;
          const end = toMinutes(seg.end24H) - START * 60;

          const left = (start / totalMinutes) * 100;
          const width = ((end - start) / totalMinutes) * 100;

          return (
            <div
              key={i}
              className={styles.segment}
              style={{
                left: `${left}%`,
                width: `${width}%`,
                background: seg.color,
              }}
            >
              <TooltipWrapper
                tooltip={
                  <div className={styles.segmentTooltip}>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Medium}
                    >
                      Start Time : {seg.start12H}
                    </Text>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Medium}
                    >
                      End Time : {seg.end12H}
                    </Text>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Medium}
                    >
                      Total Time Tracked : {seg.totalTimeTracked}
                    </Text>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Medium}
                    >
                      Idle Time : {seg.idleTime}
                    </Text>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Medium}
                    >
                      Activity Pct : {seg.activityPct}
                    </Text>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Medium}
                    >
                      Idle Percent : {seg.idlePercent}
                    </Text>
                  </div>
                }
                wrapperClassName={styles.segmentTooltipHost}
              >
                <div className={styles.segmentTooltipHit} />
              </TooltipWrapper>
            </div>
          );
        })}
      </div>

      {/* Scale */}
      <div className={styles.scale}>
        {Array.from({ length: END - START + 1 }).map((_, i) => {
          const hour = START + i;
          return (
            <div key={hour} className={styles.tickWrapper}>
              <div className={styles.tick} />
              <div className={styles.label}>{formatHour(hour)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const formatHour = (h) => {
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  return `${hour.toString().padStart(2, '0')} ${ampm}`;
};
